import { LiveLikeOption } from "@livelike/engagementsdk";
const html = (window as any).html;

class SBSImagePredictionFollowupOption extends LiveLikeOption {
  createRenderRoot(): this {
    return this;
  }

  votePercentage = () => {
    const items: any[] = (this as any).items || [];
    const totalVotes = items.reduce(
      (a: number, b: any) => a + (b?.vote_count || 0),
      0
    );
    const myVotes = (this as any).item?.vote_count || 0;
    return totalVotes > 0 ? Math.round((myVotes / totalVotes) * 100) : 0;
  };

  render() {
    const pct = this.votePercentage();
    this.style.setProperty("--vote-pct", `${pct}%`);
    return html`
      <div class="sbs-option-fill"></div>
      <livelike-image height="60px"></livelike-image>
      <span class="sbs-option-percent">${pct}%</span>
    `;
  }
}
customElements.define(
  "sbs-image-prediction-followup-option",
  SBSImagePredictionFollowupOption as any
);
